<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">
      {{ 'BATCH_MAILING.RECEIPTS_TAB.FORMED_RECEIPT' | translate }}
    </h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <app-invoice-item [item]="item" [compact]="true"></app-invoice-item>
  </div>

  <div class="modal-footer modal-footer--right">
    <button
      class="button button--filled button--shadow"
      type="button"
      placement="bottom"
      (click)="hide('saved')"
    >
      {{ 'CLOSE' | translate }}
    </button>
  </div>
</div>
